import AddIcon from "../../../../core/assets/icons/commons/add.svg";
import CartIcon from "../../../../core/assets/icons/commons/cart.svg";
import CoupangIcon from "../../../../core/assets/icons/commons/coupang.svg";
import { LanguageCode } from "core/constants";
import { useAuthModal } from "core/context";

const RecipeIngredientsLoading = () => {
  const { token } = useAuthModal();
  return (
    <div className="animate-pulse flex w-full">
      <div className="flex-1 space-y-6 py-1">
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-4 place-items-center h-[34px]">
            <div className="h-4 w-full bg-gray-300 rounded col-span-1"></div>
            <div className="w-full flex justify-end">
              {token ? (
                <div className="flex item-center">
                  <img className="mx-2" src={AddIcon} alt="" />
                  <img className="mx-2" src={CartIcon} alt="" />
                  {(window as any)._APP_LANG === LanguageCode.ko && 
                    <img className="mx-2" src={CoupangIcon} alt="" />
                  }
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecipeIngredientsLoading;
